import css from './questionList.module.scss';

import { memo } from 'react';

import { getDashboardUrl } from 'core/paths';
import { FrameHeader } from 'core/ui/Frame';
import { Icon } from 'core/ui/icons';

import Filters from './Filters';
import List, { useQuestionList } from './List';

const QuestionList = () => {
  const listProps = useQuestionList();

  return (
    <div className={css.module}>
      <FrameHeader closeLink={getDashboardUrl()}>
        <span className={css.testNameLabel}>Questions in: </span>
        <span className={css.testName}>
          {listProps.test?.name || '…'} <Icon icon="Question" />
        </span>
      </FrameHeader>

      {listProps.test && (
        <Filters
          test={listProps.test}
          addQuestion={listProps.onAddQuestion}
          fetchInitial={listProps.fetchInitial}
          filters={listProps.filters}
          setFilter={listProps.setFilter}
          showOptions={listProps.showOptions}
          onToggleOptions={listProps.onToggleOptions}
        />
      )}

      <List
        fetchInitial={listProps.fetchInitial}
        fetchMore={listProps.fetchMore}
        questions={listProps.questions}
        filters={listProps.filters}
        setFilter={listProps.setFilter}
        isFetching={listProps.isFetching}
        test={listProps.test}
        testUid={listProps.testUid}
        onChangeQuestion={listProps.onChangeQuestion}
        onAddQuestion={listProps.onAddQuestion}
        onRemoveQuestion={listProps.onRemoveQuestion}
        showOptions={listProps.showOptions}
      />
    </div>
  );
};

export default memo(QuestionList);
